import { AsyncPipe, CommonModule, NgFor } from '@angular/common';
import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidatorFn,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { Contact } from '../../../../models/contact.model';
import { CountryService } from '../../../../services/country.service';

export class ValidatePhoneNumber {
  static validate(): ValidatorFn {
    return (controls: AbstractControl) => {
      const phoneCode = controls.get('phoneCode')?.value;
      const contact = controls.get('contact')?.value;

      if (
        phoneCode == undefined ||
        phoneCode == null ||
        phoneCode == '' ||
        contact == undefined ||
        contact == null ||
        contact == ''
      ) {
        return null; // Don't validate empty values to allow for optional fields
      }
      const regex = /^\+[1-9]\d{1,14}$/;
      const isValid = regex.test(`+${phoneCode}${contact}`);

      if (isValid) return null;

      controls.setErrors({ invalidFormat: true });
      return { invalidFormat: true };
    };
  }
}

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, NgFor, AsyncPipe, ReactiveFormsModule],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContactComponent),
      multi: true,
    },
  ],
})

// https://stackoverflow.com/questions/44766855/how-to-create-angular-2-custom-component-with-multiple-input-fields
export class ContactComponent implements OnInit, ControlValueAccessor {
  @Input() initialValue: Contact = {
    isoCode: 'IN',
    phoneCode: '91',
    contact: '',
  };

  contactForm: FormGroup;

  selectedCode: string;

  countryList: Observable<Array<any>> = new Observable();

  constructor(private countryService: CountryService) {
    this.selectedCode = this.initialValue?.isoCode ?? 'IN';
    this.contactForm = new FormGroup(
      {
        isoCode: new FormControl(this.selectedCode),
        phoneCode: new FormControl(''),
        contact: new FormControl(''),
      },
      {
        validators: [ValidatePhoneNumber.validate()],
      }
    );
  }

  ngOnInit() {
    this.countryList = this.countryService.getCountries();
    this.contactForm.patchValue({
      isoCode: this.initialValue.isoCode ?? 'IN',
      phoneCode: this.initialValue.phoneCode,
      contact: this.initialValue.contact.toString() ?? '',
    });
  }

  writeValue(value: any) {
    // console.log('writeValue: ', value);
    if (value) {
      this.contactForm.patchValue({
        isoCode: value.isoCode,
        phoneCode: value.phoneCode,
        contact: value.contact?.toString() ?? '',
      });
    } else {
      this.contactForm.reset(this.initialValue);
    }
  }

  registerOnChange(fn: (value: any) => void) {
    this.contactForm.valueChanges.subscribe(fn);
  }

  registerOnTouched() {}

  onIsoChange(isoCode: string) {
    this.selectedCode = isoCode;
    this.countryList?.subscribe((countries) => {
      const country: any = countries.find(
        (country) => country.code === isoCode
      );
      if (country == null) return;
      this.contactForm.patchValue({
        phoneCode: country.dialCodes[0].replace('+', '').replace(' ', ''), // Remove '+' and ' ' from the dial code
      });
    });
  }
}
